import { render } from "./AccueilView.vue?vue&type=template&id=0ff167be"
import script from "./AccueilView.vue?vue&type=script&lang=js"
export * from "./AccueilView.vue?vue&type=script&lang=js"

import "./AccueilView.vue?vue&type=style&index=0&id=0ff167be&lang=css"

import exportComponent from "D:\\Dev\\PenseBeteV2\\repo\\pensebete_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QList,QExpansionItem,QCard,QCardSection,QSeparator});
